import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4b38740e&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4b38740e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38740e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b38740e')) {
      api.createRecord('4b38740e', component.options)
    } else {
      api.reload('4b38740e', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=4b38740e&scoped=true&", function () {
      api.rerender('4b38740e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/comp/Voucher.vue"
export default component.exports